import { render, staticRenderFns } from "./Chunk.vue?vue&type=template&id=c205936e&scoped=true&"
import script from "./Chunk.vue?vue&type=script&lang=js&"
export * from "./Chunk.vue?vue&type=script&lang=js&"
import style0 from "./Chunk.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Chunk.vue?vue&type=style&index=1&id=c205936e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c205936e",
  null
  
)

export default component.exports